import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { SupplierActivationPeriod } from 'components/reports/Metrics/constants/SupplierActivation'
import { VehicleTypeFilter } from 'generated/graphql'

export interface SupplierActivationFilterValues {
  period: SupplierActivationPeriod
  customStart: Date | null
  customEnd: Date | null
  vehicleType: VehicleTypeFilter
}

export const SUPPLIER_ACTIVATION_DEFAULT_FILTERS: SupplierActivationFilterValues = {
  period: 'last90',
  customStart: null,
  customEnd: null,
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const SupplierActivationFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<SupplierActivationFilterValues>({
    defaultValues: SUPPLIER_ACTIVATION_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
